<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="page">
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
      <a href="#" @click.stop.prevent="$router.go(-1)" class="header-title header-subtitle">Back</a>
        <a href="#" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-dark"><i class="fas fa-sun"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-light"><i class="fas fa-moon"></i></a>
        <a href="#" data-menu="menu-main" class="header-icon header-icon-2"><i class="fas fa-bars"></i></a>
    </div>

    <footer-bar activeItem="customers" />

    <div class="page-content" id="top-of">
      <div class="page-title page-title-small">
            <h2><a href="#" @click.stop="$router.go(-1)" ><i class="fa fa-arrow-left"></i></a>Zákazníci</h2>
            <a href="#" data-menu="menu-main" class="bg-fade-highlight-light shadow-xl preload-img" data-src="images/avatars/5s.png"></a>
        </div>
        <div class="card header-card shape-rounded" data-card-height="150">
            <div class="card-overlay bg-highlight opacity-95"></div>
            <div class="card-overlay dark-mode-tint"></div>
        </div>
        
        <div class="card card-style">
          <div class="content">
              <h3 class="font-16">Zoznam zákazníkov</h3>
              <p>
                  Zoznam zákazníkov je zotriedený abecedne, a je možné ho filtgrovať podľa miest sídla zákazníka.
              </p>
              
              <div data-menu="menu-town-select" class="input-style has-borders input-style-always-active no-icon mb-4 pointer">
                  <label for="form5" class="color-black-dark font-500">Mesto</label>
                  <input type="text" class="form-control validate-text bg-white pointer" id="form5" readonly="true" :value="city">
                  <span><i class="fa fa-chevron-down"></i></span>
                  <em></em>
              </div>
              
              <div class="input-style has-borders input-style-always-active no-icon mb-4">
                  <label for="form5" class="color-black-dark font-500">Zoradiť</label>
                  <select id="form5" class="bg-white" v-model="sortCustomersBy">
                      <option value="az" selected>Abecedne A-Z</option>
                      <option value="za">Abecedne Z-A</option>
                      <option value="09">Podľa bodov 0-9</option>
                      <option value="90">Podľa bodov 9-0</option>
                  </select>
                  <span><i class="fa fa-chevron-down"></i></span>
                  <em></em>
              </div>

              <div v-if="loading" class="text-center"><div class="spinner-border color-highlight" role="status"></div></div>
              
              <div v-for="customer in customers" :key="(customer.pzsCode + '_' + customer.id + '_' + customer.idOz)">
                <div class="divider mt-3 mb-3"></div>
                <router-link :to="{ name: 'Customer Detail', params: { id: (customer.pzsCode + '_' + customer.id + '_' + customer.idOz) }}">
                  <div class="d-flex">
                      <div class="align-self-center ps-3">
                          <h4 class="font-700 font-20 mb-n1 color-highlight">{{ customer.id }}</h4>
                          <h5 class="font-600 font-12 mb-n1">{{ customer.pzsCode }}</h5>
                          <p class="color-theme mb-n2 font-11 text-truncate">{{ customer.name }}</p>
                          <p class="mb-n2 font-11">{{ customer.street }}, {{ customer.city }}</p>
                          <p class="mb-n2 font-11">{{ customer.networkName }}</p>
                          <p class="mb-n2 font-11">{{ customer.associationName }}</p>
                      </div>
                      <div class="align-self-center ms-auto">
                          <h5 class="color-black-dark mb-n1 font-20 text-end">{{ customer.points }} b.</h5>
                          <div v-if="customer.updatedTime && !customer.addedTime && !customer.deletedTime" class="mt-2 badge-number-inside bg-blue-light">Upravený</div>
                          <div v-if="customer.addedTime" class="mt-2 badge-number-inside bg-green-light">Nový</div>
                          <div v-if="customer.deletedTime" class="mt-2 badge-number-inside bg-red-light">Zmazaný</div>
                      </div>
                  </div>
                </router-link>
              </div>

              <div v-if="pageSize < filteredCustomers.length" class="divider mt-3 mb-3"></div>
              <div v-if="pageSize < filteredCustomers.length" class="text-center">
                <div @click="showMore()" class="btn btn-m mt-2 mb-2 bg-highlight rounded-sm text-uppercase font-900">
                  <i v-if="!loading" class="fa fa-caret-down me-3"></i>
                  <i v-if="loading" class="fa fa-sync fa-spin me-3"></i>
                  zobraziť ďalšie
                </div>
              </div>
          </div>
        </div>

        <!-- back to top -->
        <div class="content mt-5 mb-5">
          <a href="#" class="back-to-top-badge bg-highlight shadow-xl"><i class="fa fa-caret-up"></i><span>Back to Top</span></a>
        </div>
        <!-- footer and footer card-->
        <footer-card class="footer" />
    </div>    
    <!-- end of page content-->

    <div class="scroll-button">
      <div>
        <a href="#" class="back-to-top-badge rounded-xs back-to-top-icon-circle bg-highlight shadow-m"><i class="fa fa-angle-up p-0 m-n2"></i></a>
      </div>
    </div>

    <main-menu />
    
    <dr-theiss-page-modal />

    <select-city-modal v-model="city" />

    <logout-modal />

    <error-modal />
  </div>    
</template>

<script>
import { ref } from 'vue'
import FooterBar from '@/components/bars/FooterBar'
import FooterCard from '@/components/cards/FooterCard'
import MainMenu from '@/components/menus/MainMenu'
import DrTheissPageModal from '@/components/modals/DrTheissPageModal'
import ErrorModal from '@/components/modals/ErrorModal'
import SelectCityModal from '@/components/modals/SelectCityModal'
import storage from '@/lib/storage'

export default {
  name: 'Customers',
  components: {
    FooterBar,
    FooterCard,
    MainMenu,
    DrTheissPageModal,
    ErrorModal,
    SelectCityModal
  },
  setup() {
    const city = ref('Všetky')
    const fullCustomers = ref([])
    const customers = ref([])
    const sortCustomersBy = ref('az')
    const loading = ref(true)
    const pageSize = ref(10)
    const filteredCustomers = ref([])

    const sorters = {
      'az': function (a,b) {
        return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase())
      },
      'za': function (a,b) {
        return (b.name || "").toLowerCase().localeCompare((a.name || "").toLowerCase())
      },
      '09': function (b,a) {
        return Number((b.points || "").replaceAll("^\"|\"$", "") || 0) - Number((a.points || "").replaceAll("^\"|\"$", "") || 0)
      },
      '90': function (a,b) {
        return Number((b.points || "").replaceAll("^\"|\"$", "") || 0) - Number((a.points || "").replaceAll("^\"|\"$", "") || 0)
      },
    }

    function filterCustomers(by) {
      loading.value = true
      filteredCustomers.value = []
      fullCustomers.value.forEach(item => {
        if (city.value === 'Všetky' || city.value.toLowerCase() === item.town.toLowerCase())
        filteredCustomers.value.push(item)
      })
      filteredCustomers.value.sort(sorters[by])
      customers.value = (filteredCustomers.value || []).slice(0,pageSize.value)
      loading.value = false
    }

    function getCustomers() {
      loading.value = true
      storage.getAllCustomers()
        .then(data => {
          fullCustomers.value = data || []
          filterCustomers(sortCustomersBy.value)
        })
        .finally(() => {
          loading.value = false
        })
    }

    function showMore() {
      if (pageSize.value < fullCustomers.value.length)
        pageSize.value += 10
      if (pageSize.value > fullCustomers.value.length)
        pageSize.value = fullCustomers.value.length
      filterCustomers(sortCustomersBy.value)
    }
        
    return {
      city,
      fullCustomers,
      getCustomers,
      sortCustomersBy,
      filterCustomers,
      loading,
      customers,
      pageSize,
      showMore,
      filteredCustomers
    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
    this.getCustomers()
  },
  watch: {
    sortCustomersBy: function (value) {
      this.pageSize = 10
      this.filterCustomers(value)
    },
    city: function (value) {
      this.pageSize = 10
      this.filterCustomers(value)
    }
  }
}
</script>

<style>

</style>